import { Stepper } from "@JohnLewisPartnership/jl-design-system/dist/components/stepper/Stepper";
import { CardComponentProps } from "@~/types/types";

export function QuantityWanted({
  product,
}: Pick<CardComponentProps, "product">) {
  if (product.wanted === undefined) {
    return null;
  }

  return (
    <div data-component="QuantityWanted">
      <Stepper
        id="stepper"
        labelText="Quantity wanted"
        max={10}
        min={0}
        name="quantity"
        onChange={(quantity) => {
          document.body.dispatchEvent(
            new CustomEvent("quantityWantedUpdate", {
              detail: {
                quantity,
                pimProductId: product.aliases.pimProductId,
              },
            }),
          );
        }}
        value={product.wanted}
      />
    </div>
  );
}
